import { assetTypeLookup, representationLookup } from 'shared/digital-assets/digital-assets-lookups';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { get as _get } from 'lodash';
import { prettifySize } from 'utils/prettify';

export const editableAssetsColumns: any = [
  {
    title: 'select-all-btn',
    colSize: '3',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Image',
    colSize: '4',
    sortable: false,
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'Name',
    colSize: '7',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'filename',
  },
  {
    title: 'File size',
    colSize: '7',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'file_size',
    data: (row: any) => {
      const filesize = _get(row, 'file_size');
      return prettifySize(filesize);
    },
  },
  {
    title: 'Asset type',
    colSize: '7',
    sortable: false,
    active: false,
    col: 'asset_type',
    type: 'component',
    config: {
      label: 'Asset type',
      fieldMap: 'assetType',
      formGroup: new UntypedFormGroup({
        'asset_type': new UntypedFormControl(),
        'representation': new UntypedFormControl(),
      }),
      controlName: 'asset_type',
      controlType: 'select',
      options: assetTypeLookup,
    }
  },
  {
    title: 'Representation',
    colSize: '7',
    sortable: false,
    active: false,
    col: 'representation',
    type: 'component',
    config: {
      label: 'Representation',
      fieldMap: 'representation',
      formGroup: new UntypedFormGroup({
        'asset_type': new UntypedFormControl(),
        'representation': new UntypedFormControl(),
      }),
      controlName: 'representation',
      controlType: 'select',
      options: representationLookup,
    }
  },
];
